/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLink = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.707 2.808a4 4 0 0 1 5.512-.138l.145.138 2.828 2.828a4 4 0 0 1 .138 5.512l-.138.145-4.242 4.243a4 4 0 0 1-5.512.137l-.145-.137-2.121-2.122a1 1 0 0 1 1.327-1.492l.087.078 2.121 2.121a2 2 0 0 0 2.72.102l.109-.102 4.242-4.242a2 2 0 0 0 .102-2.72l-.102-.109-2.828-2.828a2 2 0 0 0-2.72-.102l-.109.102-1.414 1.414a1 1 0 0 1-1.492-1.327l.078-.087zM7.05 8.464a4 4 0 0 1 5.512-.137l.145.137 2.121 2.122a1 1 0 0 1-1.327 1.492L13.414 12l-2.121-2.121a2 2 0 0 0-2.72-.102l-.109.102-4.242 4.242a2 2 0 0 0-.102 2.72l.102.109 2.828 2.828a2 2 0 0 0 2.72.102l.109-.102 1.414-1.414a1 1 0 0 1 1.492 1.327l-.078.087-1.414 1.414a4 4 0 0 1-5.512.138l-.145-.138-2.828-2.828a4 4 0 0 1-.138-5.512l.138-.145z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLink as Link };
